import { questionnaireGql } from '../../../gql-gen/questionnaire'

export const UPDATE_RESPONSE_OPTION = questionnaireGql(/* GraphQL */ `
  mutation updateResponseOptionV2($input: UpdateResponseOptionV2Input!) {
    updateResponseOptionV2(input: $input) {
      ...DraftEntryResponseOption
    }
  }
`)
